<template>
    <div v-if="number" class="position-relative d-inline-block" style="margin-bottom: 15px;min-width: 240px;">
        <a style="font-size: 2rem;" class="mt-3 call" :href="'tel:'+number.replace(/ /g, '')">
                                    <span class="d-inline-block"><i class="fad fa-mobile-android me-2"></i>
                                    <span class="phone-number">{{number}}</span>
                                    </span>
        </a>
        <small class="text-primary" style="font-size: 12px;position: absolute;right: 0px;bottom: -10px"><b>{{$t('app.mention')}}</b></small>
    </div>
</template>

<script>
export default {
    props:['number'],
    name: "phone"
}
</script>

<style scoped>

</style>
